import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { kbAPI } from '../lib/api';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from './ui/sheet';
import { KbMarkdown } from './KbMarkdown';
import { HelpCircle, Loader2, BookOpen } from 'lucide-react';

const routeToSlug = {
  '/': 'dashboard',
  '/members': 'miembros-y-solicitudes',
  '/events': 'eventos',
  '/announcements': 'anuncios',
  '/posts': 'noticias',
  '/ministries': 'ministerios-y-grupos',
  '/groups': 'ministerios-y-grupos',
  '/courses': 'cursos',
  '/contributions': 'aportes',
  '/wallet': 'wallet',
  '/prayers': 'oraciones-y-peticiones',
  '/petitions': 'oraciones-y-peticiones',
  '/mentorships': 'mentorias',
  '/moderation': 'moderacion',
  '/analytics': 'analiticas',
  '/team': 'equipo-colaboradores',
  '/apoyo-pastoral': 'tu-aliado-pastoral',
  '/settings': 'configuracion',
  '/subscriptions': 'suscripciones-plan-genesis',
  '/support': 'soporte-tickets',
};

export const ContextualHelp = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(false);

  const slug = routeToSlug[pathname];
  if (!slug) return null;

  const openHelp = async () => {
    setOpen(true);
    if (article?.slug === slug) return;
    setLoading(true);
    try {
      const res = await kbAPI.get(slug);
      setArticle(res.data?.data || null);
    } catch { setArticle(null); }
    finally { setLoading(false); }
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={openHelp}
        className="text-muted-foreground hover:text-[#056A84]"
        title="Ayuda de esta pantalla"
        data-testid="contextual-help-button"
      >
        <HelpCircle className="w-5 h-5" />
        <span className="sr-only">Ayuda de esta pantalla</span>
      </Button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="w-full sm:max-w-xl overflow-y-auto" data-testid="contextual-help-panel">
          <SheetHeader className="text-left">
            <SheetTitle className="flex items-center gap-2 text-base md:text-lg">
              <BookOpen className="w-5 h-5 text-[#056A84]" />
              {loading ? 'Cargando ayuda...' : article?.title || 'Ayuda'}
            </SheetTitle>
            <SheetDescription>{article?.summary}</SheetDescription>
          </SheetHeader>

          <div className="mt-4 border-t pt-4">
            {loading ? (
              <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 spinner text-[#056A84]" /></div>
            ) : article ? (
              <KbMarkdown text={article.body} />
            ) : (
              <p className="text-sm text-muted-foreground py-8 text-center" data-testid="contextual-help-empty">
                Todavía no hay una guía para esta pantalla.
              </p>
            )}
          </div>

          <Button
            variant="outline"
            size="sm"
            className="mt-6 w-full"
            onClick={() => { setOpen(false); navigate('/help'); }}
            data-testid="contextual-help-go-center"
          >
            Ver todo el Centro de Ayuda
          </Button>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default ContextualHelp;
